import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('email_notifications'),
    optionTitleNewRequest: defineMessage('new_requests_notifications'),
    optionTitleComments: defineMessage('comments_notifications'),
    optionTitleWorkflow: defineMessage('workflow_changes'),
    optionTitleOther: defineMessage('other_notifications'),
    optionTitleSummary: defineMessage('summary_of_pending_approvals'),
    labelSentInstantly: defineMessage('sent_instantly'),
    sendSummaryReportEvery: defineMessage('send_a_report_every'),
    sendSummaryReportAt: defineMessage('at'),
};
